var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"col-lg-12 text-center mb-3"},[_vm._v(_vm._s(_vm.$t('edit')))]),_c('CategoryForm',{attrs:{"baseCategory":_vm.category,"basecategoryName":_vm.name,"isUpdate":true,"categoryType":this.$route.params.type,"loading":_vm.loading},on:{"submit-requested":_vm.submitRequested}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }